import { Button, Card } from "antd";
import { RiBodyScanLine, RiTShirtLine, RiPriceTag3Line, RiRuler2Line } from "react-icons/ri";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const GuestServices = () => {
  const { t } = useTranslation();

  return (
    <div id="guest-services" className="guest-services-bg flex justify-start pt-[9.375rem] h-screen items-center flex-col p-5 w-full overflow-y-auto">
      <div className="z-20 flex flex-col items-center justify-center w-full max-w-screen-xl mx-auto">
        <h1 className="mb-8 text-2xl font-bold text-white">{t("guest.chooseService")}</h1>
        <div className="grid w-full grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3 lg:gap-10">
          <Link to={`/${i18next.language}/guest/body-measurement`}>
            <Card
              hoverable
              className="flex flex-col items-center w-full h-full p-4 transition-all duration-300 border bg-white/5 border-white/10 backdrop-blur-md hover:bg-white/10"
              cover={
                <div className="flex items-center justify-center py-4">
                  <RiBodyScanLine className="text-6xl text-white" />
                </div>
              }
            >
              <Card.Meta
                title={<span className="block text-xl font-semibold text-center text-white">{t("services.bodyMeasurement")}</span>}
                description={<span className="block mt-2 text-sm font-normal text-center text-white/60">{t("services.bodyMeasurementDesc")}</span>}
              />
            </Card>
          </Link>
          <Link to={`/${i18next.language}/guest/auto-tagging`}>
            <Card
              hoverable
              className="flex flex-col items-center w-full h-full p-4 transition-all duration-300 border bg-white/5 border-white/10 backdrop-blur-md hover:bg-white/10"
              cover={
                <div className="flex items-center justify-center py-4">
                  <RiPriceTag3Line className="text-6xl text-white" />
                </div>
              }
            >
              <Card.Meta
                title={<span className="block text-xl font-semibold text-center text-white">Auto Tagging</span>}
                description={<span className="block mt-2 text-sm font-normal text-center text-white/60">Automatically detect clothing attributes and tags</span>}
              />
            </Card>
          </Link>
          {/* <Link to={`/${i18next.language}/guest/visual-clothes-search`}>
            <Card
              hoverable
              className="flex flex-col items-center w-full h-full p-4 transition-all duration-300 border bg-white/5 border-white/10 backdrop-blur-md hover:bg-white/10"
              cover={
                <div className="flex items-center justify-center py-4">
                  <RiTShirtLine className="text-6xl text-white" />
                </div>
              }
            >
              <Card.Meta
                title={<span className="block text-xl font-semibold text-center text-white">{t("services.visualSearch")}</span>}
                description={<span className="block mt-2 text-sm font-normal text-center text-white/60">{t("services.visualSearchDesc")}</span>}
              />
            </Card>
          </Link> */}
          <Link to={`/${i18next.language}/guest/garment-measurement`}>
            <Card
              hoverable
              className="flex flex-col items-center w-full h-full p-4 transition-all duration-300 border bg-white/5 border-white/10 backdrop-blur-md hover:bg-white/10"
              cover={
                <div className="flex items-center justify-center py-4">
                  <RiRuler2Line className="text-6xl text-white" />
                </div>
              }
            >
              <Card.Meta
                title={<span className="block text-xl font-semibold text-center text-white">Garment Measurement</span>}
                description={<span className="block mt-2 text-sm font-normal text-center text-white/60">Precise garment sizing with A4 scale reference</span>}
              />
            </Card>
          </Link>
        </div>
        <Link className="w-full max-w-xs mt-8" to={`/${i18next.language}/guest`}>
          <Button size="large" type="default" className="w-full btn-white-outline">
            {t("common.back")}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default GuestServices;
